import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from './components/pages/Home';
import { Admin } from './components/pages/Admin';
import { ActiveMembersPage } from './components/pages/ActiveMembersPage';
import { DiasporaPage } from './components/pages/DiasporaPage';
import { ProfilePdfPage } from './components/pages/ProfilePdfPage';
import { useStore } from './components/store/usestore';

function App() {
  const fetchData = useStore((state) => state.fetchData);

  // Fetch data from Supabase on app initialization
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/active-members" element={<ActiveMembersPage />} />
      <Route path="/diaspora" element={<DiasporaPage />} />
      <Route path="/profile-pdf" element={<ProfilePdfPage />} />
    </Routes>
  );
}

export default App;

